<template>
    <vue-select style="width: 100%" :value="value"
        id="product-brand-id" :options="items" :label="label" class="select-x"
        :placeholder="placeholder" @input="changed"></vue-select>
</template>

<script>
    import {HTTPAUTH} from "../lib/httplib";
    import VueSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    export default {
        components: {
            VueSelect
        },
        name: "Select2",
        props: ["items", "placeholder", "value", "label"],
        methods: {
            changed(evt) {
                this.$emit('input', evt);
            }
        }
    }
</script>
